import {takeEvery} from 'redux-saga/effects'

import {
  SP_ATT_AMENDMENT_CREATE,
  SP_ATT_AMENDMENT_LIST,
  SP_ATT_AMENDMENT_SHOW,
  SP_ATT_DAY_CAMPUS,
  SP_ATT_DAY_SUBJECT,
  SP_ATT_LEAVE_CREATE,
  SP_ATT_LEAVE_EXAMS,
  SP_ATT_LEAVE_HOMEWORK,
  SP_ATT_LEAVE_SCHEDULES,
  SP_ATT_LEAVE_TESTS,
  SP_ATT_NOTIFICATION_READ,
  SP_ATT_SUBJECT_COMBINE,
  SP_ATT_SUBJECT_INDIVIDUAL,
  SP_ATT_USER_SUBJECTS,
} from '../../Actions/SpAttendance/ActionTypes/ApiActionTypes'
import {
  STUDENT_ATTENDANCE_ACTIVITY_COMBINED,
  STUDENT_ATTENDANCE_ACTIVITY_INDIVIDUAL,
  STUDENT_ATTENDANCE_COMBINED,
  STUDENT_ATTENDANCE_INDIVIDUAL,
  STUDENT_ATTENDANCE_PARENT_RESPONSE,
  STUDENT_ATTENDANCE_REPORT_SETTINGS,
} from '../../Actions/StudentAttendance/ActionTypes/ApiActionTypes'
import fetchData from '../SagaHelper'

/**
 * Routes the parent/student attendance actions (reports, amendment requests)
 * and the family leave-request form into the shared fetch worker.
 */
function* dataSaga() {
  yield takeEvery(STUDENT_ATTENDANCE_REPORT_SETTINGS, fetchData)
  yield takeEvery(STUDENT_ATTENDANCE_INDIVIDUAL, fetchData)
  yield takeEvery(STUDENT_ATTENDANCE_COMBINED, fetchData)
  yield takeEvery(STUDENT_ATTENDANCE_PARENT_RESPONSE, fetchData)
  yield takeEvery(STUDENT_ATTENDANCE_ACTIVITY_INDIVIDUAL, fetchData)
  yield takeEvery(STUDENT_ATTENDANCE_ACTIVITY_COMBINED, fetchData)

  yield takeEvery(SP_ATT_SUBJECT_INDIVIDUAL, fetchData)
  yield takeEvery(SP_ATT_SUBJECT_COMBINE, fetchData)
  yield takeEvery(SP_ATT_USER_SUBJECTS, fetchData)
  yield takeEvery(SP_ATT_NOTIFICATION_READ, fetchData)
  yield takeEvery(SP_ATT_AMENDMENT_LIST, fetchData)
  yield takeEvery(SP_ATT_AMENDMENT_SHOW, fetchData)
  yield takeEvery(SP_ATT_AMENDMENT_CREATE, fetchData)
  yield takeEvery(SP_ATT_DAY_CAMPUS, fetchData)
  yield takeEvery(SP_ATT_DAY_SUBJECT, fetchData)
  yield takeEvery(SP_ATT_LEAVE_SCHEDULES, fetchData)
  yield takeEvery(SP_ATT_LEAVE_EXAMS, fetchData)
  yield takeEvery(SP_ATT_LEAVE_TESTS, fetchData)
  yield takeEvery(SP_ATT_LEAVE_HOMEWORK, fetchData)
  yield takeEvery(SP_ATT_LEAVE_CREATE, fetchData)
}

export default dataSaga
